import React from "react";
import { Modal, ModalBuilder, Table } from "@redriver/cinnamon";
import { archiveClientAuthorisedSignatory } from "features/Companies/Customers/Signatories/Actions/actions";

const ArchiveSignatory = ({ signatoryId, clientId, forceUpdate }) => {
  return (
    <ModalBuilder
      withForm
      submitAction={archiveClientAuthorisedSignatory}
      submitParams={{ signatoryId, clientId }}
      onSubmitted={forceUpdate}
      loadParams={{ signatoryId, clientId }}
      renderTrigger={(showModal) => (
        <Table.MenuItem onClick={showModal}>Archive</Table.MenuItem>
      )}
      renderModal={(modalProps) => (
        <Modal.Edit
          {...modalProps}
          header="Archive Signatory"
          submitLabel="Archive"
        >
          <span>Are you sure you would like to archive this signatory?</span>
        </Modal.Edit>
      )}
    />
  );
};
export default ArchiveSignatory;
